export const ADMIN_MODULE_REQUEST = "ADMIN_MODULE_REQUEST";
export const ADMIN_MODULE_SUCCESS = "ADMIN_MODULE_SUCCESS";
export const ADMIN_MODULE_FAILURE = "ADMIN_MODULE_FAILURE";
